<template>
  <div class="col-12 change-devices-col">
    <div class="change-devices-block">
      <div :class="['change-devices-block__bg', open ? 'active' : '']">
        <div @click="toggleOpen()" class="change-devices-block__switch"></div>
        <div class="change-devices-block__status">
          <span v-if="(device.configured && device.watch)" class="on">статус</span>
          <span v-else-if="(device.configured && !device.watch)" class="off">статус</span>
          <span v-else>статус</span>
        </div>
        <div class="input-wr input-wr-name">
          <label for="d1">Название</label>
          <input id="d1" type="text" disabled="" v-model="device.title">
        </div>
        <div class="input-wr">
          <label for="d2">ID</label>
          <input id="d2" type="text" disabled="" v-model="device.id">
        </div>

        <div class="select-wr">
          <label for="d3">Родительское устройство</label>
          <select v-model="device.type" name="" id="d3">

            <option v-for="type in types" :value="type.id" :key="type.id">{{type.title}}</option>

          </select>
        </div>

        <div class="input-wr">
          <label for="d5">Описание</label>
          <input id="d5" type="text" v-model="device.description">
        </div>
        <div class="change-devices-block__check style">
          <div v-if="device.watch" class="status-check" @click="toggleWatch()">
            <div class="status-check__img"></div>
            <div class="status-check__text">on</div>
          </div>
          <div v-else class="status-check disabled" @click="toggleWatch()">
            <div class="status-check__img"></div>
            <div class="status-check__text">off</div>
          </div>
        </div>
        <div class="change-devices-block__buttons">
          <span class="canceled">отмена</span>
          <span @click="configure" class="confirm">сохранить</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceAPI from '../../api/device'

export default {
  name: 'DeviceConfig',
  props: {
    device: Object,
    types: Array
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    configure (e) {
      e.preventDefault()
      let currentObj = this
      if (this.device.configured) {
        DeviceAPI.edit(this.device.dbId, {
          'name': this.device.title,
          'watch': this.device.watch,
          'deviceTypeId': this.device.type,
          'description': this.device.description,
          'stationId': parseInt(this.$parent.$route.params.id)
        })
          .then(() => {
            currentObj.$notify({
              group: 'foo',
              title: 'Успех',
              text: 'Устройство сохранено'
            })
          })
          .catch((error) => {
            currentObj.$notify({
              group: 'foo',
              title: 'Ошибка!',
              text: error
            })
          })
      } else {
        DeviceAPI.create({
          'name': this.device.title,
          'watch': this.device.watch,
          'deviceTypeId': this.device.type,
          'description': this.device.description,
          'stationId': parseInt(this.$parent.$route.params.id)
        })
          .then((response) => {
            currentObj.device.configured = true
            currentObj.device.dbId = response.data
            currentObj.$notify({
              group: 'foo',
              title: 'Успех',
              text: 'Устройство сконфигурировано'
            })
          })
          .catch((error) => {
            currentObj.$notify({
              group: 'foo',
              title: 'Ошибка!',
              text: error
            })
          })
      }
    },
    toggleOpen () {
      this.open = !this.open
    },
    toggleWatch () {
      this.device.watch = !this.device.watch
    }
  }
}
</script>
